import { createRouter, createWebHashHistory } from 'vue-router'

import createAdminRouters from './createAdminRouters.js'
const adminRoutes = createAdminRouters()



const router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{ path: '/', name: 'Home', component: () => import('@/views/Home.vue'), redirect: '/admin/OrderCenter' },
		{ path: '/about', name: 'About', component: () => import('@/views/About.vue') },
		{ path: '/client', name: 'About', component: () => import('@/views/Client.vue') },
		{ path: '/admin', name: 'Admin', component: () => import('@/admin/layouts/base_layout.vue'), redirect: '/admin/classify', children: adminRoutes, },
	]
})

const a = {
	appid: 'wxf3d37679488f0b35',
	appid_with_miniProgram: 'wx0fba6f490d770eb9',
	mch_id: '1719853822',
	serial_no: '751FAAB8116787514526DFBC06D6D5649C851D01',
	apiv3_private_key: 'Aa154733349113249995221324999522',
	private_key: `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQC+3nmjvHicX2Sr
fhNfW9OZbc5bMgN0yRTv5B4e/pMI15Iq2m27Bs0b6vVNesqJ34TQNDICzfsa9UoE
106PCVJblRbgOOIq+yZW76hYSIzdOSEIprNS9S75fnbiFdb7/U1L3wN5x0+wKaoR
T/CxIaRIzpEgWVh03+WP2ueGaVojN3tLhi3po1TIiJRPLfwS9LO29OX83ZyWEgQa
oeSZBnUTnCzt9PWEbEuTSLSWjGkHsn7fHF8ar2MJutnPSYUAihyZ2TVfmWV//SHF
YFGfD1oiY4gY6OkWUPFs9XlmXb1kxOrGaUmQpLhhLesRY2GTbY0efrnd2Wd+DzDR
sP3Yy4XPAgMBAAECggEAfz97APopvraqOtq2t6BUlblrFclmHHnih3whyLAX/pEZ
VZCCD2odXDtshtcSKJDnzpa9sLj6a6KUUl3oddvVGFFxCtNhlR4TFWp5ZUIZB3OK
3mWkr+3d/1+cimXdCep5mdd4TbvfGKbuRtRwtuaizBdLEbH/Ewwh06IxMJ8UBN1V
X56BfHGGAU/PIwEO127q9GzWNTt8JGyPOSBueMomT1hp9ULpvi5ldgIkvNWHqW8B
Y61iGpUhnA+q0RdrFO0v63jSzj4nBoOLZasEef0Tiszs+p3f1gslx0o4IMtObjA6
/8oZ5V5pSB4HGKFe8doGXJwIDqn3DfPMcqAl83+84QKBgQDkxU3ic9VCyZC155id
K8TiWRnR2hftbqY8WjpwyxGTl7HhWIf4kHXLL4m3k6EMaCUZe3QXurCuHxBAsTeL
bEAUIqBcnt25lcxDlLxE4ySJtk6h2l2LiE31sMy0jaG0kpUS4Flx4XT89bIfEgSD
MDfXifxSwSjTdQ2izj+XK74QMwKBgQDVlkxZpUUvZHxasmR+hDPzwJKewJXpdxoa
6zmiw8IHO2C2tBNxJWnoBlRPuc6IGsRuuY9y5bTPNKwayetHnymLczXDXE0E4H8W
tmFiCb3geiQWdNqpQYsa8EJdhQWJaPCsnF7EiiGPjgiQE9oCEBjnfCsAy3It8e10
kgFkr5jn9QKBgQCur4ZwY5i1vepVLHpZkYFugTD5D/rzX2lqbk9vr3BFbjDy7MIu
6Eg6FZuoZP811RR3J9CXCgQ9gRTNAUVznf40IdinwNt4Cc2G0T0NsRBGY8IZTv/d
OwCkmhNFz1xp4QAaANvr3IeTXR1dIkn1zszlNcVJf5toFFqMNcdS7KDeBwKBgG0+
Im73iRtkWfZJp/zNwYS6ykNIXWS79i4ugZwuY98vD5hjIk6MxE5YbmcYsfoLNs0r
O6OYuZIBbsWE4UIQtj8M/kKdwwbrjBUh001BjkxyLGMQAYbwbyWoHUmX7+0IL5EZ
qZ78x42VJ+wJO0gy04oSiCwv4oZ9ZuZohy3oYlzBAoGABoiae/yOEbrqno8OuWAV
NyTZi1NCu3BDTqRBXpxaR//a1J2oG4b4dk3i1I7lNh/hkJsLGGpcITp9EPQpHnzg
nbIp3rdRppWDAz/Z+eW/+saHgZoRpJK4zZTNPsV1seV+gIgoKB7Jg2Xh+DKGCL1V
y61IRyxFRK2n9B/25uXA05s=
-----END PRIVATE KEY-----`,
}

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

//全局进度条的配置
NProgress.configure({
	showSpinner: true,  //加载微调器设置,默认为true
	//使用缓动（CSS缓动字符串）和速度（以毫秒为单位）调整动画设置。（默认：ease和200）
	easing: 'ease',
	showSpinner: false,
	speed: 1000,
})

//对路由钩子函数进行设置
//路由进入前
router.beforeEach((to, from, next) => {
	console.log("ahshsah")
	NProgress.start();
	next();
});
//路由进入后
router.afterEach(() => {
	NProgress.done()
})

// router.beforeEach((to, from) => {
//   console.log(to)
//   // ...
//   // 返回 false 以取消导航

// })

router.adminRoutes = adminRoutes


export default router
